<page-header class="tenant-title"
	pageTitleKey="TenantName"
	[pageTitle]="tenantName() | uppercase">

	@if (tenantLogo()) {
		<div page-header-area="icon" class="tenant-logo"
			[style.background-image]="'url('+tenantLogo()+')'"></div>
	}
</page-header>

<div class="user-actions">
	<multi-search-input
		[groups]="searchGroups()"
		[results]="searchResultsWithMore()"
		(inputChanged)="search($event)"
		(pick)="pickSearchResult($event)"
	/>

	<button data-cy="OpenNotifications" class="btn-notifications btn-badged" (click)="toggleNotificationsPanel()">
		<i class="far fa-bell" ngbTooltip="{{'TopBar.Tooltip.Notifications' | translate}}" placement="left" container="body"></i>
		@if (notifications.unreadCount(); as unread) {
			<span class="badge badge-pill badge-secondary">{{(unread <= 9) ? unread : '9+' }}</span>
		}
	</button>

	<div ngbDropdown placement="bottom-right">
		<button data-cy="OpenHelp" class="btn-help no-carret" ngbDropdownToggle>
			<i class="far fa-info-circle"></i>
		</button>
		<div class="dropdown-menu" ngbDropdownMenu>
			<button data-cy="SelectLanguage" (click)="openHelp()" class="dropdown-item" translate="TopBar.Tooltip.OnlineHelp"></button>
			<button data-cy="SupportContact" (click)="cpcSupportPhone()" class="dropdown-item" translate="TopBar.Tooltip.Contact"></button>
		</div>
	</div>

	@if (hasTranslations) {
		<div data-cy="OpenLanguages" class="user-languages" ngbDropdown placement="bottom-right" (openChange)="userMenuOpened()">
			<button class="btn btn-primary" ngbDropdownToggle data-cy="DropdownToggle">
				{{ currentLanguage() | language : true }}
			</button>
			<div class="dropdown-menu" ngbDropdownMenu>
				<button data-cy="SelectLanguage" (click)="setLanguage(fr)" class="dropdown-item">FR</button>
				<button data-cy="SelectLanguage" (click)="setLanguage(en)" class="dropdown-item">EN</button>
			</div>
		</div>
	}

	@if (!!user()) {
		<div data-testid="UserAccountMenu" class="user-account" ngbDropdown placement="bottom-right" (openChange)="userMenuOpened()">
			<user-avatar [user]="user()" [hasPopover]="false" ngbDropdownToggle data-cy="DropdownToggle" class="no-carret"/>
			<div ngbDropdownMenu>
				<div class="d-flex">
					<user-popover-content class="my-1 ml-4 mr-5" size="large" [infos]="userInfos()" />

					<div>
						@if (!(operator$ | async)?.isSupport) {
							<button class="dropdown-item" data-cy="EditMyInfos" (click)="editMyInformations()">
								<i class="mr-2 fa fa-user"></i> {{ 'TopBar.Account.MyAccount' | translate }}</button>
						}
						<button data-cy="OpenThemes" class="dropdown-item" (click)="toggleThemesPanel()">
							<i class="mr-2 far fa-palette"></i> {{ 'App.Themes.Title' | translate }}</button>
						@if (canUpdatePlatform$ | async) {
							<button data-cy="OpenUpdatePlatform" class="dropdown-item" (click)="updatePlatform()">
								<i class="mr-2 fa fa-arrows-rotate"></i> {{ 'TopBar.Account.UpdatePlatform' | translate }}</button>
						}
						@if ((config$ | async).consoleUrl) {
							<button data-cy="LeavePlatform" class="dropdown-item" (click)="leavePlatform()">
								<i class="mr-2 fa fa-door-open"></i> {{ 'TopBar.Account.Leave' | translate }}</button>
						}
						@if (('partnerUrl' | branding)(); as partnershipsUrl) {
							<a [href]="partnershipsUrl" data-cy="OpenPartnerships" class="dropdown-item">
								<i class="mr-2 fa fa-handshake-simple"></i> {{ 'TopBar.Account.Partnerships' | translate }}</a>
						}
						@if (('newsUrl' | branding)(); as newsUrl) {
							<a [href]="newsUrl" data-cy="OpenNews" class="dropdown-item">
								<i class="mr-2 fa fa-newspaper"></i> {{ 'TopBar.Account.News' | translate }}</a>
						}
						<button data-cy="Logout" class="dropdown-item" (click)="userLogout()">
							<i class="mr-2 fa fa-power-off"></i> {{ 'TopBar.Account.LogOut' | translate }}</button>
					</div>
				</div>
			</div>
		</div>
	}
</div>
